import { c as _c } from "react/compiler-runtime";
import { RoleAutocomplete } from "@components/role/role-autocomplete/role-autocomplete";
import { FaroCoreApiConst } from "@stellar/core-api-client";

/** Renders a dropdown to select project role */
export function ProjectRoleAutoComplete(t0) {
  const $ = _c(13);
  const {
    selectedRole,
    onChange,
    onResetSelection,
    placeholder: t1,
    disabledRoles: t2,
    isRequired,
    isDisabled
  } = t0;
  const placeholder = t1 === undefined ? "Select a role..." : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const disabledRoles = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["RESOURCE_OWNER"];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== disabledRoles) {
    t5 = t4.concat(disabledRoles);
    $[3] = disabledRoles;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = t5;
  let t7;
  if ($[5] !== isDisabled || $[6] !== isRequired || $[7] !== onChange || $[8] !== onResetSelection || $[9] !== placeholder || $[10] !== selectedRole || $[11] !== t6) {
    t7 = <RoleAutocomplete labelTitle="Project role" isRequired={isRequired} isDisabled={isDisabled} selectedRole={selectedRole} onChange={onChange} onResetSelection={onResetSelection} placeholder={placeholder} roles={FaroCoreApiConst.allProjectRoles} disabledRoles={t6} link="projectRolesHelp" dataTestId="project-role-selector" />;
    $[5] = isDisabled;
    $[6] = isRequired;
    $[7] = onChange;
    $[8] = onResetSelection;
    $[9] = placeholder;
    $[10] = selectedRole;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}